

export class Ref<T> {
  constructor (
    public current: T,
    private handleChange?: () => void,
  ) {}

  set = (ref: T) => {
    this.current = ref
    this.handleChange && this.handleChange()
  }
}
